// Global toast queue (DESIGN.md section 9.4) — the ONE place any screen surfaces "something
// happened but there's nowhere in-context to show it", chiefly badge scans on screens that have
// no contextual meaning for a scan (Live, Past matches, Rankings, Versus, Player, Debug). Home
// and New match keep their own contextual scan behavior (store/draft.ts) and do NOT toast on
// top of it — the screen transition / filled side IS the feedback there.
//
// Rendered by components/ToastStack.vue, mounted once in App.vue so it's visible regardless of
// which screen (or overlay) is current. Stacked, not serialized: several scans in a row show as
// several toasts rather than clobbering one another, each with its own ~4s auto-dismiss timer.
import { reactive } from 'vue'
import type { Player } from '../types'

export interface Toast {
  id: number
  kind: 'success' | 'error'
  message: string
  player?: Player | null
}

const TOAST_DURATION_MS = 4000

export const toastStore = reactive<{ items: Toast[] }>({ items: [] })

let nextId = 1

export function pushToast(kind: Toast['kind'], message: string, player: Player | null = null): number {
  const id = nextId++
  toastStore.items.push({ id, kind, message, player })
  setTimeout(() => dismissToast(id), TOAST_DURATION_MS)
  return id
}

export function dismissToast(id: number) {
  const idx = toastStore.items.findIndex((t) => t.id === id)
  if (idx !== -1) toastStore.items.splice(idx, 1)
}
